import CookieStorage from '../Storage/CookieStorage';

export default class ListrakBase {
  public constructor(protected cookies: CookieStorage) {}

  protected getListrak() {
    return typeof window !== 'undefined' ? window._ltk : undefined;
  }

  protected async getOrderKey(): Promise<any> {
    const { data: orderKey } = await this.cookies.get('order_key');
    return orderKey;
  }
}
